import { render, staticRenderFns } from "./UiInputFile.vue?vue&type=template&id=4e499fb3&"
import script from "./UiInputFile.vue?vue&type=script&lang=js&"
export * from "./UiInputFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports